module.exports = __webpack_public_path__ + "img/icon-phone.1b15a83f.svg";